import React from 'react';

import { useTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react';

import { Slider } from '@components/slider';

import { config } from '@/config';

import { breakpointsConfig, getInfoByBrand } from './config';
import * as Styled from './info.styled';

const Info = () => {
	const { t } = useTranslation('coin_race');
	const brand = config.BRAND;

	const info = getInfoByBrand(brand);

	return (
		<Styled.SliderWrapper>
			<Slider spaceBetween='16px' pagination={false} navigation={false} breakpoints={breakpointsConfig}>
				{info.map((item, index) => (
					<SwiperSlide key={index}>
						<Styled.InfoItem>
							<Styled.InfoItemDescription>
								<Styled.InfoItemTitle>{t(item.title)}</Styled.InfoItemTitle>
								<Styled.InfoItemDescriptionText>{t(item.description)}</Styled.InfoItemDescriptionText>
							</Styled.InfoItemDescription>

							<Styled.InfoItemImage src={item.image} alt={item.title} />
						</Styled.InfoItem>
					</SwiperSlide>
				))}
			</Slider>
		</Styled.SliderWrapper>
	);
};

export default Info;
